import {observable, action} from 'mobx';
import {LayerOptions} from '../layer.types';

export abstract class BaseLayer {
    @observable public visible: boolean;

    @observable public opacity: number;

    @observable public zIndex: number;

    @observable public layerVersion: number = 0;

    constructor(
        public id: string,
        public type: string,
        options?: LayerOptions
    ) {
        this.visible = options?.visible ?? true;
        this.opacity = options?.opacity ?? 1;
        this.zIndex = options?.zIndex ?? 0;
    }

    @action
    public invalidate(): void {
        this.layerVersion++;
    }

    abstract render(
        ctx: CanvasRenderingContext2D,
        containerWidth: number,
        containerHeight: number,
        renderOptions?: Record<string, any>
    ): void;
}
